export default __webpack_public_path__ + "84b5cb389d8eaf131d581fb70ac6e3bc.svg";